import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, Button, Dialog, Grid, Typography } from '@mui/material';
import { Inspection } from 'api/Responses/OrderResponses';
import { useLanguage } from 'context/AppContext';
import { ModalContent } from '../DeliveryPortalPage.styles';
import { DeliveryPortalUploadListStatus } from '../pages/DeliveryPortalUploadList';
import DuplicatesTable from './DuplicatesTable';

interface DuplicatesTableModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  isShown: boolean;
  duplicates: Inspection[];
  setDuplicates: (data: Inspection[]) => void;
  setPageState: (data: DeliveryPortalUploadListStatus) => void;
}

const DuplicatesTableModal: React.FC<DuplicatesTableModalProps> = ({
  onCancel,
  onConfirm,
  isShown,
  duplicates,
  setDuplicates,
  setPageState,
}) => {
  const [language] = useLanguage();

  return (
    <Dialog open={isShown} maxWidth="xl" fullWidth>
      <ModalContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
          <DuplicatesTable duplicates={duplicates} setDuplicates={setDuplicates} />
        </Box>
        <Box sx={{ mb: 4 }} />
        <Typography align="center">{language.DeliveryPortal.DuplicatesTable.text}</Typography>
        <Box sx={{ mb: 4 }} />
        <Grid justifyContent="space-between" container spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              startIcon={<HighlightOffIcon color="error" />}
              onClick={() => setPageState(DeliveryPortalUploadListStatus.VIEWING)}
            >
              {language.DeliveryPortal.DuplicatesTable.cancelButton}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              startIcon={<CheckCircleOutlineIcon color="success" />}
              onClick={() => setPageState(DeliveryPortalUploadListStatus.UPLOADING_CONFIRM_DUPLICATES)}
            >
              {language.DeliveryPortal.DuplicatesTable.confirmButton}
            </Button>
          </Grid>
        </Grid>
      </ModalContent>
    </Dialog>
  );
};

export default DuplicatesTableModal;
